import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

(async () => {
  try {
    const platform = platformBrowserDynamic();
    const moduleRef = await platform.bootstrapModule(AppModule);

    // Hide splash screen after app bootstrap
    const splash = document.getElementById('splash-screen');
    if (splash) splash.style.display = 'none';

  } catch (err) {
    console.error('Error bootstrapping app', err);
  }
})();
